<template>
  <article class="flex flex-col lg:col-span-6 group">
    <a
      :href="hit.url"
      class="block mb-6 md:mb-8"
      aria-hidden="true"
    >
      <img
        :src="hit.imageLetterbox ?? '/static/blog-fallback.webp'"
        alt=""
        class="object-cover h-full w-full shadow-white group-hover:scale-[1.03] transition-transform "
        height="240"
        loading="lazy"
        width="436"
      >
    </a>
    <ul
      v-if="hit.blogCategories?.length"
      class="flex items-start mb-3 flex-wrap gap-1"
    >
      <li
        v-for="category in hit.blogCategoriesExpanded"
        :key="category.id"
        class="grow-0"
      >
        <a
          :href="category.url"
          class="rounded-full px-2 py-0.5 inline-flex text-xs font-medium justify-center items-center text-blue-700 hover:text-blue-800 bg-blue-200 hover:bg-blue-300"
        >
          {{ category.title }}
        </a>
      </li>
    </ul>

    <a
      :href="hit.url"
      class="flex flex-col gap-2 md:gap-3 group"
    >
      <h3 class="text-xl md:text-2xl lg:text-3xl link link--primary font-display">
        {{ hit.title }}
      </h3>

      <span class="text-sm font-semibold">{{ formatDate(hit.postDate) }}</span>

      <AisSnippet
        attribute="excerpt"
        :hit="hit"
        :class-names="{
          'ais-Snippet': 'prose prose-sm',
        }"
      />
    </a>
  </article>
</template>

<script lang="ts">
export default { name: 'BlogHit' }
</script>

<script setup lang="ts">
import { AisSnippet } from 'vue-instantsearch/vue3/es'

import { Hit } from '~/types/Hit'
import { formatDate } from '~/utils/format'

defineProps<{ hit: Hit }>()
</script>
